/*
 * @Author: your name
 * @Date: 2021-06-07 22:54:48
 * @LastEditTime: 2021-06-21 23:00:33
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \web_page\src\store\loginUser.js
 */
// 登录用户 的仓库数据
import { login, check_login, loginOut } from "@/api/userAPI";

export default {
    // 开启命名空间
    namespaced: true,
    state: {
        user_data: null, // 当前登录的用户信息
        islogining: false, // 是否正在远程加载中
    },
    mutations: {
        // 仓库数据改动必须通过mutation,没有例外,再mutations里面配置所有变化，每种变化都是一个函数
        // state 原来的状态
        // payload 负荷，有的话有且只有一个，可以是任何一个
        // mutation 里面不能有副作用操作，异步，改动或使用外部数据等。
        // 用this.$store.commit(mutations里的函数,payload修改的值)来调用mutation 命名空间内容部的话，直接用函数，命名空间外部的话用 命名空间名/函数
        setUserData(state, payload) {
            state.user_data = payload;
        },
        setIsLogining(state, payload) {
            state.islogining = payload;
        },
    },
    actions: {
        // 副作用操作的函数在这里
        // 函数参数：function(context,payload)
        // context 相当于是仓库对象
        // payload 负荷,可以没有
        // 触发action 使用dispatch(action里的函数,payload修改的值) 例如 this.$store.dispatch('命名空间名/函数'，payload);
        // 注意必须通过mutation修改仓库的数据
        // action里面修改仓库数据，用content.commit（mutations里的函数,payload修改的值）修改仓库数据
        async login(content, payload) {
            content.commit("setIsLogining", true);
            var resp = await login(payload);
            if (resp.result) {
                content.commit("setUserData", resp.user_info);
            }
            content.commit("setIsLogining", false);
            return resp;
        },
        async check_login(content) {
            content.commit("setIsLogining", true);
            var resp = await check_login();
            // 判断是否登录成功
            if (resp !== "login_error") {
                content.commit("setUserData", resp);
                content.commit("setIsLogining", false);
                return true;
            } else {
                content.commit("setIsLogining", false);
                return false;
            }
        },
        loginOut(content) {
            content.commit("setUserData", null);
            content.commit("setIsLogining", false);
            loginOut();
        },
    },
};
